<template>
  <div class="messageDetailDialog">
    <el-dialog
      append-to-body
      :title="msgData.title"
      :visible.sync="dialogVisible"
      width="800px"
      center
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="msg-type-time-wrap">
        <el-tag type="warning" size="mini" class="msg-type">{{
          msgData.typeName
        }}</el-tag>
        <span>{{ msgData.time }}</span>
      </div>
      <div class="msg-content" v-html="msgData.content"></div>
      <div class="bottom-btn-wrap" slot="footer">
        <el-button @click="close">关闭</el-button>
        <el-button
          type="primary"
          @click="onPageJump"
          v-if="!computedNotShowCheckBtn"
        >
          查看详情
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      msgData: {},
    };
  },
  computed: {
    // 系统消息不需要展示“查看详情”按钮
    // 结算消息不需要展示“查看详情”按钮
    computedNotShowCheckBtn() {
      return (
        this.msgData.typeName === "系统消息" ||
        this.msgData.typeName === "结算消息"
      );
    },
  },
  methods: {
    show(msgData) {
      this.dialogVisible = true;
      this.msgData = msgData;
      console.log("弹窗的消息内容-----", msgData);
    },
    close() {
      this.dialogVisible = false;
    },
    // 跳转到对应页面
    onPageJump() {
      this.$emit("onPageJump", this.msgData);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 16px !important;
  .el-dialog__title {
    font-weight: bold;
  }
  .el-dialog__body {
    padding-top: 3px !important;
  }
}

.msg-type-time-wrap {
  border-top: 1px solid #e4e4e4;
  padding: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-size: 12px;
    color: #999;
  }
  .msg-type {
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.msg-content {
  padding: 16px 0;
  font-size: 14px;
  color: #333;
  img {
    display: block;
    margin: auto;
    max-width: 100% !important;
    line-height: 1;
  }
}
</style>
